// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"29":"ca26d18e","67":"8c49f3ae","239":"d05c624c","658":"ca26d18e","906":"8c49f3ae"}[chunkId] + ".chunk.css";
};